import { render, staticRenderFns } from "./MessageAll.vue?vue&type=template&id=e9010730&scoped=true&"
import script from "./MessageAll.vue?vue&type=script&lang=js&"
export * from "./MessageAll.vue?vue&type=script&lang=js&"
import style0 from "./MessageAll.vue?vue&type=style&index=0&id=e9010730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9010730",
  null
  
)

export default component.exports